import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonItem, IonInput, IonLabel } from "@ionic/vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneticIdInput',
  props: {
    geneticId: null
  },
  emits: ["update:geneticId"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), { lines: "full" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLabel), { position: "stacked" }, {
        default: _withCtx(() => [
          _createTextVNode("登録する遺伝子検査ID")
        ]),
        _: 1
      }),
      _createVNode(_unref(IonInput), {
        type: "text",
        clearInput: true,
        value: __props.geneticId,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:geneticId', $event.target.value))),
        required: ""
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})